import Header from '../components/Header';
import Gallery from '../components/Gallery';
import Footer from '../components/Footer';

const GalleryPage = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main>
        <Gallery />
      </main>
      <Footer />
    </div>
  );
};

export default GalleryPage;